// i18n area 'auth' — locale sr-Latn-RS (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Script LATINO (srpska latinica, da ratificare).
// Sidecar anti-stantie: ../meta/auth.sr-Latn-RS.meta.json.
import type { enUS } from './auth'

export const srLatnRS: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Prijavite se na svoj nalog',
    username: 'Korisničko ime',
    usernamePlaceholder: 'Unesite korisničko ime',
    usernameHint: 'Koristite korisnik@domen za autentifikaciju na realmu direktorijuma',
    continue: 'Nastavi',
    changeUser: 'Niste vi?',
    password: 'Lozinka',
    forgotPassword: 'Zaboravili ste lozinku?',
    submit: 'Prijavi se',
    otp: 'Jednokratni kod',
    otpSubtitle: 'Unesite kod iz svog autentifikatora',
    otpHint: 'Šest cifara iz aplikacije za autentifikaciju, ili jedan od kodova za oporavak',
    otpSubmit: 'Proveri',
    invalidCredentials: 'Neispravno korisničko ime ili lozinka',
    tooManyAttempts: 'Previše pokušaja — sačekajte trenutak i pokušajte ponovo',
    realmUnavailable: 'Realm trenutno ne može da proveri akreditive — store klastera nije dostupan. Prijavite se kao lokalni korisnik (break-glass).',
    genericError: 'Prijava nije uspela — da li je TVirt backend dostupan?'
  },
  user: {
    logout: 'Odjavi se',
    password: {
      menu: 'Promeni lozinku',
      title: 'Promenite svoju lozinku',
      current: 'Trenutna lozinka',
      new: 'Nova lozinka',
      confirm: 'Potvrdite novu lozinku',
      mismatch: 'Lozinke se ne poklapaju',
      error: 'Lozinku nije moguće promeniti',
      forcedTitle: 'Promenite lozinku da biste nastavili',
      forcedHint: 'Ovu lozinku je postavio administrator i mora se zameniti pre ulaska.',
      forcedSubmit: 'Promeni i uđi'
    },
    mfa: {
      title: 'Dvofaktorska autentifikacija',
      subtitle: 'Drugi faktor koji se traži pri svakoj prijavi',
      loadError: 'Stanje drugog faktora nije moguće učitati',
      enrolled: 'Aktivan',
      notEnrolled: 'Nije aktivan',
      enrolledAt: 'Aktivirano',
      codesRemaining: 'Preostali kodovi za oporavak',
      requiredHint: 'Administrator zahteva drugi faktor na ovom nalogu: konfigurišite ga sada — dok to ne uradite možete da se prijavite, ali malo šta drugo.',
      enroll: 'Konfiguriši',
      enrollTitle: 'Konfigurišite dvofaktorsku autentifikaciju',
      enrollHint: 'Skenirajte ovaj kod aplikacijom za autentifikaciju, zatim ukucajte kod koji ona prikazuje da biste potvrdili.',
      secretHint: 'Ne možete da ga skenirate? Ukucajte ovu tajnu u aplikaciju:',
      code: 'Kod iz aplikacije',
      confirm: 'Potvrdi',
      startError: 'Konfiguraciju nije moguće pokrenuti',
      confirmError: 'Konfiguraciju nije moguće potvrditi',
      codesTitle: 'Vaši kodovi za oporavak',
      codesWarning: 'Ovi kodovi se prikazuju samo jednom. Sačuvajte ih sada: svaki vas prijavljuje kada autentifikator nije dostupan, i važi samo jednom.',
      codesAck: 'Kodovi za oporavak su sačuvani',
      codesDone: 'Gotovo',
      copy: 'Kopiraj',
      copied: 'Kopirano',
      download: 'Preuzmi',
      regenerate: 'Novi kodovi za oporavak',
      regenerateTitle: 'Regenerišite kodove za oporavak',
      regenerateHint: 'Svi do sada izdati kodovi prestaju da rade u trenutku kada se generiše novi set.',
      regenerateConfirm: 'Regeneriši',
      regenerateError: 'Kodove za oporavak nije moguće regenerisati',
      remove: 'Ukloni',
      removeTitle: 'Uklonite drugi faktor',
      removeConfirm: 'Ukloni',
      removeHint: 'Nalog se vraća samo na lozinku. Drugi faktor možete ponovo konfigurisati kad god želite.',
      removeRequiredHint: 'Administrator zahteva drugi faktor na ovom nalogu, pa će server odbiti uklanjanje — zamolite ga prvo da ukine obavezu.',
      removeError: 'Drugi faktor nije moguće ukloniti'
    },
    profile: {
      menu: 'Idi na moj profil',
      sessions: 'Aktivne sesije',
      sessionsHint: 'Vaše otvorene sesije na ovom čvoru',
      sessionsEmpty: 'Nema aktivnih sesija',
      sessionCreated: 'Prijava',
      sessionExpires: 'Ističe',
      revoke: 'Opozovi sesiju',
      revokeError: 'Sesiju nije moguće opozvati',
      loadError: 'Sesije nije moguće učitati'
    }
  }
}
